import jQuery from 'jquery'
import _ from 'underscore'

Object.assign(window, { $: jQuery, jQuery, _ })

try { Rails.start() } catch { }